import { Injectable } from '@angular/core';
import { RestApi } from 'app/auth/rest.api';
import { Observable } from 'rxjs';

@Injectable()
export class UserGroupsService {

  private _getEndPoint = 'api/UserGroups';
  private _getPropertiesEndPoint = 'api/UserGroups/condition/properties';

  constructor(private _restApi: RestApi) { }

  public get(): Promise<IUserGroup[]> {
    return this._restApi.get(this._getEndPoint).toPromise();
  }

  public getProperties() {
    return this._restApi.get(this._getPropertiesEndPoint).toPromise();
  }

  public delete(guids: Array<Guid>): Observable<any> {
    return this._restApi.deleteFromBody(`${this._getEndPoint}`, guids);
  }
  
  public getById(id: Guid): Promise<IUserGroup> {
    return this._restApi.get(`${this._getEndPoint}/${id}`).toPromise();
  }

  public update(userGroup: IUserGroup): Promise<IUserGroup> {
    return this._restApi.put(`${this._getEndPoint}`, userGroup).toPromise();
  }

  
  public create(userGroup: IUserGroup): Promise<IUserGroup>  {
    return this._restApi.post(`${this._getEndPoint}`, userGroup).toPromise();
  }
}
